  var sku_values_l = ''; //Valor de todas las combinaciones colocadas en el ojo izquierdo
  var sku_values_r = ''; //Valor de todas las combinaciones colocadas en el ojo derecho
  var var_l_col = ''; //Este es el valor del COL en el ojo izquierdo
  var var_r_col = ''; //Este es el valor del COL en el ojo derecho
  var val_upc = '';//Este es el valor del UPC que será asignado a través del siguiente desarrollo 


$('#left-color').click(function() {
    var_l_col = $('#4866231173198_option_3').val();
	console.log(var_l_col); 
	unify_values_l();
	fetch_sku_l();
});

$('#right-color').click(function() {
    var_r_col = $('#4866231173198_option_4').val();
	console.log(var_r_col); 
	unify_values_r();
	fetch_sku_r();
});


function unify_values_l(){
	sku_values_l =  var_l_col;
	console.log(sku_values_l);
}

function unify_values_r(){
	sku_values_r =  var_r_col;
	console.log(sku_values_r);
}

function l_upc(){
	//if(sku_values_l.indexOf('Amatista') !== -1){val_upc = ''; $('#left-upc input').val(val_upc);}

	if(sku_values_l.indexOf('Azul') !== -1){val_upc = '20500000607963';        $('#left-upc input').val(val_upc);}
	if(sku_values_l.indexOf('Marrón') !== -1){val_upc = '20500000607772';      $('#left-upc input').val(val_upc);}
	if(sku_values_l.indexOf('Gris') !== -1){val_upc = '20500000607789';        $('#left-upc input').val(val_upc);}
	if(sku_values_l.indexOf('Verde') !== -1){val_upc = '20500000607765';       $('#left-upc input').val(val_upc);}
	if(sku_values_l.indexOf('Intenso') !== -1){val_upc = '20500000656541';     $('#left-upc input').val(val_upc);}
	if(sku_values_l.indexOf('Amatista') !== -1){val_upc = '20500000458442';    $('#left-upc input').val(val_upc);}
	if(sku_values_l.indexOf('Vibrante') !== -1){val_upc = '20500000656534';    $('#left-upc input').val(val_upc);}
	if(sku_values_l.indexOf('Avellano') !== -1){val_upc = '20500000607901';    $('#left-upc input').val(val_upc);}
	if(sku_values_l.indexOf('Zafiro') !== -1){val_upc = '20500000607970';      $('#left-upc input').val(val_upc);}
	if(sku_values_l.indexOf('Esmeralda') !== -1){val_upc = '20500000608007';   $('#left-upc input').val(val_upc);}
	if(sku_values_l.indexOf('Turquesa') !== -1){val_upc = '20500000607918';    $('#left-upc input').val(val_upc);}
	if(sku_values_l.indexOf('Miel') !== -1){val_upc = '20500000607796';        $('#left-upc input').val(val_upc);}
}

function r_upc(){
	if(sku_values_r.indexOf('Azul') !== -1){val_upc = '20500000607963';        $('#right-upc input').val(val_upc);}
	if(sku_values_r.indexOf('Marrón') !== -1){val_upc = '20500000607772';      $('#right-upc input').val(val_upc);}
	if(sku_values_r.indexOf('Gris') !== -1){val_upc = '20500000607789';        $('#right-upc input').val(val_upc);}
	if(sku_values_r.indexOf('Verde') !== -1){val_upc = '20500000607765';       $('#right-upc input').val(val_upc);}
	if(sku_values_r.indexOf('Intenso') !== -1){val_upc = '20500000656541';     $('#right-upc input').val(val_upc);}
	if(sku_values_r.indexOf('Amatista') !== -1){val_upc = '20500000458442';    $('#right-upc input').val(val_upc);}
	if(sku_values_r.indexOf('Vibrante') !== -1){val_upc = '20500000656534';    $('#right-upc input').val(val_upc);}
	if(sku_values_r.indexOf('Avellano') !== -1){val_upc = '20500000607901';    $('#right-upc input').val(val_upc);}
	if(sku_values_r.indexOf('Zafiro') !== -1){val_upc = '20500000607970';      $('#right-upc input').val(val_upc);}
	if(sku_values_r.indexOf('Esmeralda') !== -1){val_upc = '20500000608007';   $('#right-upc input').val(val_upc);}
	if(sku_values_r.indexOf('Turquesa') !== -1){val_upc = '20500000607918';    $('#right-upc input').val(val_upc);}
	if(sku_values_r.indexOf('Miel') !== -1){val_upc = '20500000607796';        $('#right-upc input').val(val_upc);}
}


function fetch_sku_l(){
 	switch (sku_values_l) { 
case 'Amatista' : $('#left-sku input').val('601659'); l_upc(); break;
case 'Azul Vibrante' : $('#left-sku input').val('992375'); l_upc(); break;
case 'Azul' : $('#left-sku input').val('598232'); l_upc(); break;
case 'Marrón' : $('#left-sku input').val('598805'); l_upc(); break;
case 'Gris Intenso' : $('#left-sku input').val('991927'); l_upc(); break;
case 'Verde' : $('#left-sku input').val('599949'); l_upc(); break;
case 'Gris' : $('#left-sku input').val('599376'); l_upc(); break;
case 'Miel' : $('#left-sku input').val('600515'); l_upc(); break;
case 'Avellano Puro' : $('#left-sku input').val('690646'); l_upc(); break;
case 'Zafiro' : $('#left-sku input').val('690073'); l_upc(); break;
case 'Verde Esmeralda' : $('#left-sku input').val('974623'); l_upc(); break;
case 'Turquesa' : $('#left-sku input').val('601086'); l_upc(); break;


 	    default:
        $('#left-sku input').val('SKU Desconocido');
    }
}//fetch_sku()



function fetch_sku_r(){
 	switch (sku_values_r) {
case 'Amatista' : $('#right-sku input').val('601659'); r_upc(); break;
case 'Azul Vibrante' : $('#right-sku input').val('992375'); r_upc(); break;
case 'Azul' : $('#right-sku input').val('598232'); r_upc(); break;
case 'Marron' : $('#right-sku input').val('598805'); r_upc(); break;
case 'Gris Intenso' : $('#right-sku input').val('974623'); r_upc(); break;
case 'Verde' : $('#right-sku input').val('599949'); r_upc(); break;
case 'Gris' : $('#right-sku input').val('599376'); r_upc(); break;
case 'Miel' : $('#right-sku input').val('600515'); r_upc(); break;
case 'Avellano Puro' : $('#right-sku input').val('690646'); r_upc(); break;
case 'Zafiro' : $('#right-sku input').val('690073'); r_upc(); break;
case 'Verde Esmeralda' : $('#right-sku input').val('991927'); r_upc(); break;
case 'Turquesa' : $('#right-sku input').val('601086'); r_upc(); break;


 		default:
        $('#right-sku input').val('SKU Desconocido');
    }
}//fetch_sku()
